module.exports = __webpack_public_path__ + "img/白薇.4625eda6.jpg";